<template>
  <div>
    <v-btn
      block
      color="green darken-1"
      class="white--text"
      dark
      @click="sendLeads"
    >
      Send Selected
    </v-btn>
    <v-checkbox
      @change="selectAllHandler"
      v-model="selectAll"
      label="Select all"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "SendLeads",
  data() {
    return {
      selectAll: false,
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    ...mapMutations({
      SET_SELECTED_POOL: "leads/SET_SELECTED_POOL",
    }),
    sendLeads() {
      if (this.selectedPool) {
        const params = this.selectedPool;

        this.$axios
          .post("/telcast", params)
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((e) => {
            console.log(e);
            this.showHandlerSnackbar({
              color: e.response.data.status,
              text: e.response.data.message,
              show: true,
            });
          });
      } else {
        this.showHandlerSnackbar({
          color: "red",
          text: "Leads are not selected!",
          show: true,
        });
      }
    },
    selectAllHandler() {
      if (this.selectAll) {
        this.SET_SELECTED_POOL(this.leads);
      } else {
        this.SET_SELECTED_POOL([]);
      }
    },
  },
  computed: {
    ...mapGetters({
      leads: "leads/leads",
      selectedPool: "leads/selectedPool",
      leadFilters: "filters/leadFilters",
    }),
  },
};
</script>

<style>
</style>